import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import InvalidProductImage from "../assets/invalidproduct.png";

const InvalidProduct = () => {
  const navigate = useNavigate();
 const { state } = useLocation();

  const scratchNumber = state?.scratchNumber;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#fff",
      }}
    >
      <div>
        <h3 style={{ textAlign: "center", marginBottom: "20px" ,marginTop:"20px"}}>
        Scratch Number : <span style={{ fontWeight: "bold" }}>{scratchNumber}</span> 
      </h3>
        <img onClick={() => navigate("/warranty")}
          src={InvalidProductImage}
          alt="Invalid Product"
           style={{
            flex: "1 1 500px",
            maxWidth: "100%",
            minWidth: "300px",
            width: "100%",
            height: "auto",
            borderRadius: "12px",
          }}
        />
      </div>
      <div>
        {/* <button
          onClick={() => navigate("/")}
          style={{
            marginTop: "10px",
            padding: "12px 35px",
            backgroundColor: "#005487",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            fontSize: "16px",
            fontWeight: "600",
            cursor: "pointer",
            transition: "0.3s",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#003d66")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#005487")}
        >
          Retry
        </button> */}
      </div>


    </div>
  );
};

export default InvalidProduct;